var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert open",class:[
    { 'alert-with-icon': _vm.icon },
    _vm.verticalAlign,
    _vm.horizontalAlign,
    _vm.alertType,
  ],style:(_vm.customPosition),attrs:{"data-notify":"container","role":"alert","data-notify-position":"top-center"},on:{"click":_vm.tryClose}},[_c('span',{attrs:{"data-notify":"message"}},[(_vm.title)?_c('span',{staticClass:"title"},[_c('b',[_vm._v(_vm._s(_vm.title)),_c('br')])]):_vm._e(),(_vm.message)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e(),(!_vm.message && _vm.component)?_c('content-render',{attrs:{"component":_vm.component}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }